module.exports = __webpack_public_path__ + "img/project-3.202b1b68.jpg";